export default {
  title: "Мой профиль",
  saved: "Профиль сохранён",
  account: {
    title: "Аккаунт",
    fullName: "Полное имя",
    username: "Логин",
    role: "Роль",
    branch: "Филиал",
    manager: "Менеджер",
    memberSince: "В системе с",
    managed: "Управляется вашим менеджером. Для изменения обратитесь к нему.",
  },
  timezone: {
    title: "Часовой пояс",
    myTime: "Моё время",
    branchHint: "Часовой пояс филиала: {{tz}}",
    driverTimes: "Время водителей показывается во времени его штата + в вашем.",
  },
  notifications: {
    title: "Уведомления",
    inApp: "Уведомления в приложении",
    telegram: "Telegram",
    telegramHint: "На следующем этапе",
  },
  password: {
    title: "Смена пароля",
    current: "Текущий пароль",
    new: "Новый пароль",
    confirm: "Подтвердите новый пароль",
    mismatch: "Пароли не совпадают",
    hint: "Не менее 10 символов. Не совпадает со старым паролем.",
    update: "Обновить пароль",
    updated: "Пароль обновлён",
    failed: "Не удалось сменить пароль",
  },
  twofa: {
    title: "Двухфакторная аутентификация",
    requiredRole: "Обязательна для вашей роли",
    disable: "Отключить",
    enable: "Включить 2FA",
    ownerAdvice: "Для аккаунта владельца рекомендуем 2FA: она защищает всю компанию.",
    intro: "Защитите аккаунт 6-значным кодом из приложения-аутентификатора (Google Authenticator, Authy, 1Password).",
    step1: "1. Отсканируйте этот QR-код приложением-аутентификатором.",
    manual: "Не сканируется? Введите ключ вручную:",
    step2: "2. Введите 6-значный код из приложения.",
    backupHint: "После включения вы получите 10 резервных кодов. Они показываются только один раз.",
    backupTitle: "Резервные коды — сохраните их сейчас, они показываются только один раз.",
    savedThem: "Я сохранил(а)",
    enabledText: "Включено. Код будет запрашиваться при каждом входе.",
    newPhone: "Новый телефон? Отключите 2FA и настройте заново.",
    newPhoneAskOwner: "Новый телефон? Попросите владельца сбросить вашу 2FA (Admin → Users), затем настройте заново.",
    newPhoneOwner: "Новый телефон? Снимите отметку «Владелец» в Settings → Security, отключите 2FA и настройте заново.",
    enabledToast: "Двухфакторная аутентификация включена",
    disabledToast: "Двухфакторная аутентификация отключена",
    enableFailed: "Не удалось включить 2FA",
    disableFailed: "Не удалось отключить 2FA",
    disableTitle: "Отключить двухфакторную аутентификацию",
    disableDesc: "Подтвердите паролем.",
    password: "Пароль",
    qrAlt: "QR-код",
  },
};
